var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "union-sync-card" },
    [
      _c(
        "div",
        {
          staticClass: "sync-header",
          attrs: { slot: "header" },
          slot: "header",
        },
        [
          _c("i", { staticClass: "el-icon-refresh" }),
          _vm._v(" "),
          _c("span", [_vm._v("数据同步管理")]),
          _vm._v(" "),
          _c(
            "el-tag",
            {
              staticClass: "ml10",
              attrs: {
                type: _vm.syncStatus === "running" ? "warning" : "info",
                size: "mini",
              },
            },
            [_vm._v("\n      " + _vm._s(_vm.syncStatusText) + "\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sync-overview mb20" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 15 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "status-item" }, [
                  _c("div", { staticClass: "status-icon success" }, [
                    _c("i", { staticClass: "el-icon-check" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "status-content" }, [
                    _c("div", { staticClass: "status-value" }, [
                      _vm._v(_vm._s(_vm.lastSyncTime || "未同步")),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "status-label" }, [
                      _vm._v("最后同步时间"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "status-item" }, [
                  _c("div", { staticClass: "status-icon info" }, [
                    _c("i", { staticClass: "el-icon-office-building" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "status-content" }, [
                    _c("div", { staticClass: "status-value" }, [
                      _vm._v(_vm._s(_vm.syncStats.unionCount || 0)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "status-label" }, [
                      _vm._v("已同步工会"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "status-item" }, [
                  _c("div", { staticClass: "status-icon warning" }, [
                    _c("i", { staticClass: "el-icon-user" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "status-content" }, [
                    _c("div", { staticClass: "status-value" }, [
                      _vm._v(_vm._s(_vm.syncStats.memberCount || 0)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "status-label" }, [
                      _vm._v("已同步会员"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sync-actions" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-card", { staticClass: "action-card" }, [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { staticClass: "el-icon-s-data" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("全量同步")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "action-content" }, [
                      _c("p", { staticClass: "action-description" }, [
                        _vm._v(
                          "\n              同步所有工会信息和会员数据，适用于首次初始化或定期全面更新。\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "action-buttons" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.loading.fullSync,
                              },
                              on: { click: _vm.handleFullSync },
                            },
                            [
                              _c("i", { staticClass: "el-icon-refresh" }),
                              _vm._v(
                                "\n                开始全量同步\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("el-card", { staticClass: "action-card" }, [
                    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                      _c("i", { staticClass: "el-icon-s-operation" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("增量同步")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "action-content" }, [
                      _c("p", { staticClass: "action-description" }, [
                        _vm._v(
                          "\n              分别同步工会基本信息和会员数据，可独立执行，适用于日常更新。\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "action-buttons" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                loading: _vm.loading.unionBase,
                              },
                              on: { click: _vm.handleSyncUnionBase },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-office-building",
                              }),
                              _vm._v(
                                "\n                同步工会信息\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                loading: _vm.loading.unionUser,
                              },
                              on: { click: _vm.handleSyncUnionUser },
                            },
                            [
                              _c("i", { staticClass: "el-icon-user" }),
                              _vm._v(
                                "\n                同步会员数据\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-card",
        { staticClass: "page-sync-card mt20" },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("i", { staticClass: "el-icon-document" }),
              _vm._v(" "),
              _c("span", [_vm._v("分页同步")]),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content:
                      "用于大数据量场景下的分批同步，可控制每次同步的数据量",
                    placement: "top",
                  },
                },
                [_c("i", { staticClass: "el-icon-question ml5" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "page-sync-section" },
                  [
                    _c("h4", [_vm._v("工会信息分页同步")]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { inline: "", size: "small" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "页码" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "100px" },
                              attrs: { min: 1, max: 1000, size: "small" },
                              model: {
                                value: _vm.pageSync.unionBase.current,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageSync.unionBase,
                                    "current",
                                    $$v
                                  )
                                },
                                expression: "pageSync.unionBase.current",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "页大小" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100px" },
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.pageSync.unionBase.size,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageSync.unionBase,
                                      "size",
                                      $$v
                                    )
                                  },
                                  expression: "pageSync.unionBase.size",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: 50, label: "50" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { value: 100, label: "100" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { value: 200, label: "200" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { value: 500, label: "500" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  loading: _vm.loading.unionBasePage,
                                },
                                on: { click: _vm.handleSyncUnionBasePage },
                              },
                              [
                                _vm._v(
                                  "\n                执行同步\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c(
                  "div",
                  { staticClass: "page-sync-section" },
                  [
                    _c("h4", [_vm._v("会员数据分页同步")]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      { attrs: { inline: "", size: "small" } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "页码" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "100px" },
                              attrs: { min: 1, max: 1000, size: "small" },
                              model: {
                                value: _vm.pageSync.unionUser.current,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.pageSync.unionUser,
                                    "current",
                                    $$v
                                  )
                                },
                                expression: "pageSync.unionUser.current",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "页大小" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100px" },
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.pageSync.unionUser.size,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.pageSync.unionUser,
                                      "size",
                                      $$v
                                    )
                                  },
                                  expression: "pageSync.unionUser.size",
                                },
                              },
                              [
                                _c("el-option", {
                                  attrs: { value: 50, label: "50" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { value: 100, label: "100" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { value: 200, label: "200" },
                                }),
                                _vm._v(" "),
                                _c("el-option", {
                                  attrs: { value: 500, label: "500" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "small",
                                  loading: _vm.loading.unionUserPage,
                                },
                                on: { click: _vm.handleSyncUnionUserPage },
                              },
                              [
                                _vm._v(
                                  "\n                执行同步\n              "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.syncLogs.length > 0
        ? _c("el-card", { staticClass: "sync-log-card mt20" }, [
            _c(
              "div",
              { attrs: { slot: "header" }, slot: "header" },
              [
                _c("i", { staticClass: "el-icon-document-checked" }),
                _vm._v(" "),
                _c("span", [_vm._v("同步日志")]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "fr",
                    attrs: { type: "text", size: "small" },
                    on: { click: _vm.clearLogs },
                  },
                  [_vm._v("清空日志")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sync-logs" },
              _vm._l(_vm.syncLogs, function (log, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "log-item", class: log.type },
                  [
                    _c("div", { staticClass: "log-time" }, [
                      _vm._v(_vm._s(log.time)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "log-content" }, [
                      _vm._v(_vm._s(log.message)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "log-status" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: log.success ? "success" : "danger",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(log.success ? "成功" : "失败") +
                                "\n          "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }